<template>
    <div class="modal-header">
        <slot></slot>
        <button type="button" class="btn-close" aria-label="Close" @click="$parent.dismiss()"></button>
    </div>
</template>

<script>
export default {
    name: "ModalHeader",
    props: {
        closeButton: {required: false, type: Boolean, default: false}
    },
    computed: {
        name() {
            return this.$parent.name;
        }
    }
}
</script>

<style scoped>

</style>
